import { render, staticRenderFns } from "./SideNavLink.vue?vue&type=template&id=1bf48ef0&"
import script from "./SideNavLink.vue?vue&type=script&lang=js&"
export * from "./SideNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports